// Auto-generated normalizer for table: RespuestaExamenVerdaderoFalso
export function respuestaExamenVerdaderoFalsoNormalize(row) {
  return {
    idExamenRespuestaVerdaderoFalso: row.idExamenRespuestaVerdaderoFalso ?? row.IdExamenRespuestaVerdaderoFalso ?? row['IdExamenRespuestaVerdaderoFalso'] ?? 0,
    idExamenRespuesta: row.idExamenRespuesta ?? row.IdExamenRespuesta ?? row['IdExamenRespuesta'] ?? 0,
    respuesta: row.respuesta ?? row.Respuesta ?? row['Respuesta'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
